export const PAST_TAB_PATH = '/app/organization/reporting/past'
export const PAST_TAB_PATH_ROOT = '/app/organization/reporting'
export const UPCOMING_TAB_PATH = '/app/organization/reporting/upcoming'
export const AVAILABILITY_SUMMARY_PATH = '/app/organization/reporting/availability'
export const ROUTING_PATH = '/app/organization/reporting/routing'

export const DASHBOARD_TABS = {
  PAST_EVENTS: 'past_events',
  UPCOMING_EVENTS: 'upcoming_events',
}

export const DEFAULT_DATE_RANGE = 30
export const DATE_RANGES = [7, 30, 60, 90, 365]
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_WITH_TIME_ZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'
export const DATE_OFFSET_LIMIT = 365
export const DATE_RANGES_WITH_UNITS = {
  TODAY: 'day',
  THIS_WEEK: 'week',
  THIS_MONTH: 'month',
  NEXT_WEEK: 'week',
  NEXT_MONTH: 'month'
}

export const ROUTING_DATE_RANGE_PERIODS = {
  TODAY: 'today',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  ALL_TIME: 'all_time',
  FIXED: 'fixed',
}

export const ROUTING_DATE_RANGES_WITH_UNITS = {
  TODAY: 'day',
  THIS_WEEK: 'week',
  THIS_MONTH: 'month'
}

export const VALID_ROUTING_RANGES = [
  ROUTING_DATE_RANGE_PERIODS.ALL_TIME,
  ROUTING_DATE_RANGE_PERIODS.TODAY,
  ROUTING_DATE_RANGE_PERIODS.THIS_WEEK,
  ROUTING_DATE_RANGE_PERIODS.THIS_MONTH,
  ROUTING_DATE_RANGE_PERIODS.FIXED
]

export const AVAILABILITY_CAPACITY_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  BUFFER: 'buffer',
  REMAINING: 'remaining',
}

export const COLLECTION_NAME = {
  EVENT_TYPES: 'event_types',
  GROUPS: 'groups',
  GROUP_MEMBERS: 'group_members',
  TEAMS: 'teams',
  USER: 'user',
  USERS: 'users'
}

export const EVENT_DISTRIBUTION_BY_DURATION_ORDER = {
  DURATION: 'duration:asc',
  VOLUME: 'volume:desc'
}

export const REPORT_STATUS = {
  EVENTS_COUNT: 'events_count',
  LAST_EVENT_OCCURRED: 'last_event.occurred',
  OCCURRED: 'occurred',
  BOOKED: 'booked',
  CANCELLED: 'cancelled',
  RESCHEDULED_CANCELLED: 'rescheduled.cancelled',
  RESCHEDULED: 'rescheduled',
  NOT_CONNECTED: 'not_connected',
  HAS_ERRORS: 'has_errors'
}

export const REPORT_COLORS = [
  '#7839F4',
  '#F3B849',
  '#0096FA',
  '#1EEEF6',
  '#FF5260',
  '#CCB5FB',
  '#F8D28C',
  '#A0D9FF',
  '#BFFAFC',
  '#FFD5D8'
]
